import { FilterEnum } from "@/types";
import { useSearchParams } from "react-router-dom";
import TextInput from "../form-controls/TextInput";
import { SearchIcon } from "lucide-react";


interface IProps {
    placeholder?: string
    styles?: string
}

export default function Searchbox({ placeholder, styles }: IProps) {
    const [searchParams, setSearchParams] = useSearchParams();

    const onChange = (data: string) => {
        const params = new URLSearchParams(searchParams);
        params.set(FilterEnum.SEARCH, data);
        setSearchParams(params);
    }

    return (
        <div className="relative">
            <TextInput 
                className={`w-80 placeholder:font-extralight  ${styles}`}
                placeholder={placeholder} 
                onChange={(event) => onChange(event.target.value)}
            />
            <SearchIcon className="absolute right-3 top-2 text-secondary-200" />
        </div>

            
    )
}